import React from "react";
import styled from "styled-components";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export default function LinkChain({ linkList }) {
  const { t } = useTranslation();

  return (
    <StyledLinkChain>
      {linkList.map((i) => (
        <li key={i.id}>
          {i.to ? (
            <>
              <Link to={i.to}>{t(t(i.title))}</Link>
            </>
          ) : (
            <p>{t(t(i.title))}</p>
          )}
        </li>
      ))}
    </StyledLinkChain>
  );
}

const StyledLinkChain = styled.ul`
  display: flex;
  align-items: center;
  gap: 32px;

  li {
    a {
      color: var(--extra-light-blue);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 146.667% */
      position: relative;

      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        height: 0.5px;
        background-color: var(--extra-light-blue);
        transition: 0.4s ease;
      }

      &:hover {
        &::before {
          width: 100%;
        }
      }

      &::after {
        content: "";
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: var(--extra-light-blue);
        top: 50%;
        right: -13px;
        transform: translate(100%, -50%);
      }
    }

    p {
      color: var(--white);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 23px; /* 146.667% */
    }
  }
`;
